<template>
  <div
    v-if="!client.hasOwnProperty('active')"
    class="tag-wrapper"
    @mouseleave="showTable = false"
  >
    <!--  v-if="client.bad_number_state_id !== null"-->
    <span
      class="label tag-bad-number table-tag-content"
      @mouseenter="showTable = true"
      ><span
        v-if="client.bad_number_state_id !== null ? false : true"
        @click.prevent="
          $emit('cancelAssign');
          showCancelAssign = false;
        "
        class="fas fa-hourglass-start"
      >
      </span>

      <span v-if="client.bad_number_state_id !== null" @click="fillterMain">
        {{ client.bad_number_state.short_name
        }}<span class="last-online-time" v-if="checkLastOnline() && !showRemove"
          >|{{ formatDateTime(client.last_online)
          }}<span class="online"></span></span></span
      ><span v-else></span>
      <a @click.prevent="$emit('delete')"
        ><span v-if="showRemove" class="fas fa-times remove-tag-icon"></span></a
    ></span>

    <div
      v-if="
        client.bad_number_state_id !== null && showTable && client.bn.length > 0
      "
      class="tag-table pop-up-for-tags"
    >
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Time</th>
              <th>FullName</th>
              <th>State</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in client.bn" :key="item.id">
              <!--   <td>{{ formatDateTable(client.ni.created_at)}}</td>
                                      <td>{{ client.ni.created_at | shortTime }}</td>-->
              <td
                :class="{
                  inBetweenSelectedCalDates: checkSelectedCalDates(item)
                }"
              >
                {{ formatDateTable(item.updated_at) }}
              </td>
              <td
                :class="{
                  inBetweenSelectedCalDates: checkSelectedCalDates(item)
                }"
              >
                {{ item.updated_at | shortTime }}
              </td>
              <td>{{ item.user.full_name }}</td>
              <td>{{ client.bad_number_state.name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "BN",
  props: {
    client: {
      type: Object,
      required: true
    },
    showRemove: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showTable: false,
      showCancelAssign: true
    };
  },
  computed: {
    ...mapState("clients", ["BNTimer", "generalQueryObject"])
  },
  watch: {},
  mounted() {},
  methods: {
    checkSelectedCalDates(ldDit) {
      let ldIn = moment(ldDit.created_at);
      let start = moment(
        this.generalQueryObject.group_assigned_at_from
      ).startOf("day");
      let to = moment(this.generalQueryObject.group_assigned_at_to).endOf(
        "day"
      );
      if (ldIn.isBetween(start, to)) {
        return true;
      } else {
        return false;
      }
    },
    fillterMain() {
      this.$store.commit("clients/setFilterToMain", {
        title: "bn",
        type: true
      });
    },
    checkLastOnline() {
      const now = moment().subtract(2, "hours"); //todays date
      const end = moment(String(this.client.last_online)); //.format("HH:mm")//.format("HH:mm");//moment("2015-12-1"); // another date
      const diff = now.diff(end, "minutes");
      if (diff < 1560 && diff >= 0) {
        // return diff + " m";
        return true;
      }
      if (diff > 1560) {
        //return 0 + " m";
        return false;
      }
    },

    formatDateTime(date) {
      return moment(String(date)).format("HH:mm ");
    },
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM ");
    }
  }
};
</script>

<style scoped>
.tag-bad-number {
  background-color: #121313;
  /*margin: 0;*/
  /*padding: 3px;*/
  /*cursor: pointer;*/
  /*font-family: "Montserrat" !important;*/
  /*border-radius: 0px;*/
  /*animation: flash linear 1s;*/
  min-width: 36px !important;
  text-align: center !important;
  max-width: 62px !important;
}

@keyframes flash {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 3;
  }
}

.tag-wrapper {
  display: inline-flex;
  position: relative;
  text-align: center;
}

.tag-table {
  bottom: 34px !important;

  border: solid 1px #121313;
}

.table-responsive {
  margin-bottom: -18px;
  border-radius: 5px;
}

.remove-tag-icon {
  color: white;
  cursor: pointer;
  margin-left: 5px;
}

.remove-tag-icon:hover {
  color: #f44336;
}

.waiting-tag-icon {
  margin-right: 4px;
  cursor: pointer;
}

.fa-hourglass-start {
  cursor: pointer;
}
.online {
  height: 8px;
  width: 8px;
  background-color: yellow;
  border-radius: 50%;
  position: absolute;
  top: 6px;
  right: 5px;
}
.last-online-time {
  margin-right: 8px;
}
.label {
  padding: 4px 2px 4px 2px;
  font-size: 12px;
}
.inBetweenSelectedCalDates {
  /*background: lightgrey;*/
  /*border: 1px solid white !important;*/
  color: blue;
}
tbody > tr:nth-of-type(odd) {
  background-color: lightgrey;
}
/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: grey;
  border-radius: 10px;
}
</style>
